/** @file This file contains utilities for working with HTML. */
import { coerceToString } from './string';
const reUnescapedHtml = /[&<>"'`]/g;
const reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
/** Used to map characters to HTML entities. */
const htmlEscapes = Object.freeze({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;',
});
/**
 * Escape a string, allowing it to be used as raw HTML without any injection danger.
 *
 * @param inputString The string to escape.
 * @returns The content of `inputString` but then escaped and ready for direct HTML usage.
 */
export function escape(inputString) {
    const str = coerceToString(inputString);
    if (str !== '' && reHasUnescapedHtml.test(str)) {
        return str.replace(reUnescapedHtml, ent => htmlEscapes[ent]);
    }
    return str;
}
